import React from 'react';
import {connect} from 'react-redux';
import './ThankYou.css';
import Price from '../../shared/price';
import {FaThumbsUp} from 'react-icons/fa';
import {clearTransactions} from "../../store/actions/transactions";

class ThankYou extends React.Component {

    componentWillUnmount() {
        if (this.props.transactions) {
            this.props.clearTransactions();
        }
    }


    render() {
        let successInfo;
        let failureInfo;
        let successArray = this.props.transactions.filter(transaction => transaction.paymentState === 'SUCCESS');
        let failureArray = this.props.transactions.filter(transaction => transaction.paymentState === 'FAILURE');
        let classes;

        if (this.props.transactions) {
            successInfo = this.props.transactions.filter(transaction => transaction.paymentState === 'SUCCESS')
            if (successInfo) {
                successInfo.map(transaction => {
                    return (
                        <div key={transaction.id} className="success-list">
                            {
                                this.props.indexedProduct[transaction.productId].links ?
                                    <img src={this.props.indexedProduct[transaction.productId].links.thumbnail}
                                         alt="thumbnail" className="tile-img"/> :
                                    null
                            }
                            <h4>{this.props.indexedProduct[transaction.productId].descriptiveName} (<Price
                                price={transaction.buyPrice}/>)</h4>
                        </div>
                    );
                });
            }


            failureInfo = this.props.transactions
                .filter(transaction => transaction.paymentState === 'FAILURE')
                .map(transaction => {

                    return (
                        <div key={transaction.id} className="failed-list">
                            <span>{this.props.indexedProduct[transaction.productId].descriptiveName} (<Price
                                price={transaction.buyPrice}/>)</span>
                        </div>
                    );
                });
        }

        if (failureArray.length > 0 && successArray.length < 1) {
            classes = "thank-you-container positionCenter";
        } else {
            classes = "thank-you-container";
        }

        return (
            <div className={classes}>
                {failureArray.length > 0 && successArray.length < 1 ? null :
                    <div className="thank-you-msg">
                        <FaThumbsUp size="2em"/>
                        <h2>Thank you for your purchase!</h2>
                    </div>
                }
                {successArray.length > 0 ? <h3 className="purchased-header">Your Purchased Items</h3> : null}
                <div className="successful-container">
                    {successInfo}
                </div>

                {failureArray.length > 0 ?
                    <h3 className="failed-purchased-header">Your purchases shown below have failed</h3> : null}
                <div className="failure-container">
                    {failureInfo}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    transactions: state.transactionsReducer.finished,
    indexedProduct: state.productsReducer.indexedProduct,
    coupon: state.couponReducer.coupon,
    orderForm: state.orderFormReducer.orderForm
});

const mapDispatchToProps = dispatch => ({
    clearTransactions: () => dispatch(clearTransactions())
});

export default connect(mapStateToProps, mapDispatchToProps)(ThankYou);
